<template>
    <div style="background-color: #210f03; display: flex; flex-direction: column;">
        <div style="height: 93px;">
            <div @click="closeImageViewer" style="padding-top: 26px; padding-left: 20px; width: 60px;">
                <img style="width: 40px;" :src="require('@/assets/img/recent_x_btn.png')" alt="">
            </div>
        </div>
        <div style="flex: 1; overflow: hidden; display: flex; align-items: center;">
            <img style="width: 100%;" :src="imagePath" alt="">
        </div>
        <div style="height: 92px; margin-top: 8px;">
            <!-- <div style="font-weight: 500; font-size: 12px; line-height: 20px; color: #fff; text-align: center;">피드에 대표 이미지로 표시되는 썸네일입니다</div> -->
        </div>
    </div>
</template>

<script>
// import ImageViewer from '@/modules/ImageViewer';

export default {
    name: "MemberTalkImageViewer",
    props: {
        imagePath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            curIndex: 0,
            imageViewer: null
        }
    },
    methods: {
        closeImageViewer() {
            this.$GlobalStore.closeLastModal();
        },
        detectImageLoad(i) {
            this.imageViewer.init(this.$refs['resizeTarget' + i][0], this.$refs['imgScrollTarget' + i][0]);
        },
        detectIndexChange(i) {
            this.curIndex = i;
        }
    },
    mounted() {
        console.log(this.imagePath)
        // this.imageViewer = ImageViewer(this.$refs.transTarget, this.$refs.touchPanel);
        // this.imageViewer.setDetectIndexChange(this.detectIndexChange)
    },
}
</script>

<style scoped>
.touch_panel {
    height: 100%;
    font-size: 0px;
    overflow: hidden;
    background-color: black;
    position: relative;
}

.trans_target {
    white-space: nowrap;
    height: 100%;
}

.image_wrap {
    width: 100%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
}

.scroll_target {
    display: inline-block;
    width: 100%;
    max-height: 100%;
    overflow: auto;
}

.image_fit {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
</style>